import { Typography } from "@avenue-8/sidekick-ui";
import styled from "@emotion/styled";

export const ThreadsContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0;
  padding-top: 0.5rem;
  background-color: transparent;
  gap: 1rem;
  overflow: hidden;
  position: relative;

  &[aria-disabled="true"] {
    pointer-events: none;
    * {
      pointer-events: none;
      user-select: none;
    }
  }
`;
export const ThreadsList = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 2rem;
  gap: 0.5rem;
  height: 100%;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 0.25rem;
  }
`;
export const ThreadItemContainer = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  padding: 0.5rem 0.25rem 0.5rem 0.5rem;
  border-radius: 0.5rem;
  background-color: transparent;
  color: ${(p) => p.theme.text.colors.primary};
  cursor: pointer;
  width: 100%;
  height: 2.5rem;
  border: solid 1px transparent;
  margin-bottom: 0.25rem;

  &[aria-disabled="true"] {
    opacity: 0.3;
    pointer-events: none;
  }

  p {
    display: flex;
    gap: 0.5rem;
    align-items: center;
    overflow: hidden;
  }

  span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-right: 0.25rem;
    font-size: ${(p) => p.theme.text.fontSizes.m};
  }

  form {
    width: 100%;
    input {
      width: 100%;
      background-color: ${(p) => p.theme.colors.background};
      color: ${(p) => p.theme.input.colors.primary};
      border: solid 1px ${(p) => p.theme.input.colors.border};
      font-size: ${(p) => p.theme.text.fontSizes.m};
      font-weight: 600;
      padding: 0.125rem 0;
      border-radius: 0.25rem;
      outline: none;
    }
  }

  ${(p) => p.theme.media.mobileDown} {
    > div {
      opacity: 1;
      visibility: visible;
      background-color: ${(p) => p.theme.colors.background2};
    }
  }

  &:hover,
  &:active,
  &:focus {
    background-color: ${(p) => p.theme.colors.background3};

    > div {
      opacity: 1;
      visibility: visible;
      background-color: ${(p) => p.theme.colors.background3};
    }
  }

  &.active {
    background-color: ${(p) => p.theme.colors.background3};
    > div {
      background-color: ${(p) => p.theme.colors.background3};
    }
  }
`;
export const ThreadActions = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
  border-radius: 0.5rem;
  background-color: transparent;
  height: 100%;
  opacity: 0;
  visibility: hidden;
  overflow: hidden;
`;

export const ThreadsGroup = styled.div`
  margin-bottom: 0.5rem;
  display: flex;
  flex-direction: column;
  padding: 0 0.5rem;

  h6 {
    font-size: ${(p) => p.theme.text.fontSizes.l};
    padding-bottom: 0.5rem;
    position: sticky;
    top: 0rem;
    background-color: ${(p) => p.theme.colors.background2};
    z-index: 2;
    width: 100%;
  }
`;
export const ThreadGroupTitle = styled(Typography)`
  padding: 0 0.5rem;
`;

export const BlurBlockedOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${(p) => p.theme.colors.background2}22;
  backdrop-filter: blur(10px);
  z-index: 9998;
  pointer-events: none;
  border-radius: 1rem;
`;

export const BlockedWarningContainer = styled.div`
  position: absolute;
  width: calc(100% - 3rem);
  left: 1.5rem;
  top: 1rem;
  z-index: 9999;
  text-align: center;
  padding: 1rem;
  border: solid 1px ${(p) => p.theme.colors.border2};
  background-color: ${(p) => p.theme.colors.background};
  border-radius: 1rem;
  pointer-events: initial !important;
  user-select: initial !important;
  * {
    pointer-events: initial !important;
    user-select: initial !important;
  }
`;
